import { z } from "zod";
import { UIElementType } from "../../../AppConstants";
import { t } from "i18next";

const getZoneSchema = (locationData, zoneLocationId = null) => {
  return z.object({
    ZoneName: z
      .string()
      .min(1, { message: "Zone name is required" })
      .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("zoneList.zoneName"), isRequired: true })),
    Location: z
      .object({
        id: z.string(),
        label: z.string(),
      })
      .nullable()
      .refine((value) => value !== null && value?.id !== null, {
        message: "Location is required",
      })
      .describe(
        JSON.stringify({
          elementType: UIElementType.DROPDOWN,
          inputLabel: t("zoneList.location"),
          isMultiSelect: false,
          isRequired: true,
          options: locationData,
          isDisabled: !!zoneLocationId,
        })
      ),
  });
};

const getZoneDefaultValue = (value = null) => {
  return {
    ZoneName: value ? value?.ZoneName : "",
    Location: value ? value?.location : null,
  };
};

const getZoneAPIPostSchema = (countryCode, businessCode) => {
  return {
    countryCode: countryCode,
    businessCode: businessCode,
    zonelocation: [
      {
        ZoneLocationId: "",
        Location: null,
        ZoneName: null,
        LocationId: null,
        Deleted: false,
        CountryCode: countryCode,
        BusinessCode: businessCode,
      },
    ],
  };
};

const getZoneAuditInfoSchema = () => {
  return {
    auditInfo: [
      {
        Location: "Zone",
        LocationKey: "",
        Action: null,
        shortDesc: null,
        currentState: null,
        previousState: null,
        // payload: null,
      },
    ],
  };
};

export { getZoneSchema, getZoneDefaultValue, getZoneAPIPostSchema, getZoneAuditInfoSchema };
